import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { ChannelStatus } from '@/assets/config/dicts';
import { objToArr } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheAction',

  setup(__props) {
    const channelStatusList = objToArr(ChannelStatus, 'value', 'label');
    const formConfig = reactive({
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'input'
      }, {
        label: '上级分类',
        prop: 'parent',
        widgetType: 'Select'
      }], [{
        label: '排序',
        prop: 'sort',
        widgetType: 'input'
      }, {
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        list: channelStatusList
      }], [{
        label: '类型',
        prop: 'type',
        widgetType: 'Select'
      }, {
        label: '语言',
        prop: 'lang',
        widgetType: 'Select'
      }], [{
        label: '成人分类',
        prop: 'adultClassification',
        widgetType: 'Select',
        list: [{
          label: '是',
          value: '1'
        }, {
          label: '否',
          value: '0'
        }]
      }, {
        label: '描述',
        prop: 'description',
        widgetType: 'input'
      }]],
      formData: {
        name: '',
        parent: '',
        sort: '',
        status: '',
        type: '',
        lang: '',
        adultClassification: '',
        description: ''
      }
    });
    return (_ctx, _cache) => {
      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_FormTable, {
        col: ['20%', '30%', '20%', '30%']
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, item => {
          return _openBlock(), _createBlock(_component_FormItem, {
            "form-item": item,
            "form-data": formConfig.formData
          }, null, 8, ["form-item", "form-data"]);
        }), 256))]),
        _: 1
      })]);
    };
  }

});